export abstract class StorageKeys {
	public static readonly MLS_SEARCH_FILTERS = 'mlsSearchFilters'
	public static readonly SELECTED_AGENT_PREVIEW = 'selectedAgentPreview'
	public static readonly PIPELINE_FILTERS = 'pipelineFilters'
	public static readonly PIPELINE_SELECTED_TAB = 'pipelineSelectedTab'
	public static readonly NURTURE_POOL_SELECTED_TAB = 'nurturePoolSelectedTab'
	public static readonly NURTURE_FILTERS = 'nurtureFilters'
	// COOKIE KEYS
	/**
	 * @deprecated Use `const {oktaId} = useUserContext()` instead.
	 */
	public static readonly COOKIE_OKTA_ID = 'cookieOktaId'

	/**
	 * Use `const {companyId} = useUserContext()` instead.
	 */
	public static readonly COOKIE_COMPANY_ID = 'cookieCompanyId'

	/**
	 * Use `const {companyName} = useUserContext()` instead.
	 */
	public static readonly COOKIE_COMPANY_NAME = 'cookieCompanyName'

	// Session Storage Keys
	public static readonly SESSION_SHOULD_GOAL_BANNER_DISPLAY = 'shouldGoalBannerDisplay'
	public static readonly SESSION_SHOULD_LISTING_BANNER_DISPLAY = 'shouldListingBannerDisplay'
	public static readonly SESSION_SHOULD_TRANSACTION_BANNER_DISPLAY = 'shouldTransactionBannerDisplay'
	public static readonly NURTURING_BANNER_CLOSED = 'nurturingBannerClosed'
	public static readonly PIPELINE_BANNER_CLOSED = 'pipelineBannerClosed'
	public static readonly PROFILE_PRODUCTION_SEGMENT = 'profileProductionSegment'
	public static readonly TRANSACTION_LIST_FILTERS = 'transactionListFilters'
	public static readonly PERFORMANCE_FILTERS = 'performanceFilters'
	public static readonly PIPELNE_CARDS_PREFS = 'pipelineCardsPrefs'
}
